/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {BrowserRouter as Router, Route, Routes} from 'react-router';
import Barra from "./Barra/Barra";
import Seccion_Home from "./Secccion/Seccion_Home";
import Footer from "./Footer/Footer";
import Seccion_Catalogo from "./Secccion/Seccion_Catalogo";
import Seccion_Detalle from "./Secccion/Seccion_Detalle";

const Pagina = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Router>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{zIndex: 3}}>
                    <Barra/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1}}>
                    <Routes>
                        <Route path={"*"} element={<Seccion_Home/>}/>
                        <Route path={"/"} element={<Seccion_Home/>}/>
                        <Route path={"/Home"} element={<Seccion_Home/>}/>
                        <Route path={"/Catalogo"} element={<Seccion_Catalogo/>}/>
                        <Route path={"/Detalle/:id"} element={<Seccion_Detalle/>}/>
                    </Routes>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                    <Footer/>
                </Grid>

            </Router>


        </Grid>
    )

}
export default Pagina